import * as R from 'ramda';

const getExpenditure = (state: any) => R.pathOr([], ['PendingOrder', 'expenditure'], state)
const getOrderDetail = (state: any) => R.pathOr([], ['PendingOrder', 'orderDetail'], state)
const getRequestOption = (state: any) => R.pathOr([], ['PendingOrder', 'requestOption'], state)
const approvalOrderRequest = (state: any) => R.pathOr([], ['PendingOrder', 'approvalOrderRequest'], state)
const isOrderApprovalComplete = (state: any) => R.pathOr(false, ['PendingOrder', 'isOrderApprovalComplete', 'approval'], state)
const orderApprovalStatus = (state: any) => R.pathOr(false, ['PendingOrder', 'isOrderApprovalComplete'], state)
const orderListGridData = (state: any) => R.pathOr([], ['PendingOrder', 'orderListGridData'], state)
const gridColumns = (state: any) => R.pathOr([], ['PendingOrder', 'gridColumns'], state)
const ordersStatus = (state: any) => R.pathOr([], ['PendingOrder', 'ordersStatus'], state)
const fleetProcessingGridData = (state: any) => R.pathOr([], ['PendingOrder', 'fleetProcessingGridData'], state)
const isOrderCanceled = (state: any) => R.pathOr(false, ['PendingOrder', 'isOrderCanceled', 'approval'], state)
const getActionPopupValue = (state:any) => R.pathOr({}, ['PendingOrder', 'actionPopupValue'], state);

const selectors = {
    getExpenditure,
    getOrderDetail,
    getRequestOption,
    approvalOrderRequest,
    isOrderApprovalComplete,
    orderListGridData,
    gridColumns,
    ordersStatus,
    fleetProcessingGridData,
    orderApprovalStatus,
    isOrderCanceled,
    getActionPopupValue

}

export default selectors